import { ReactNode } from 'react';

import { Checkbox, Combobox } from '@any-ui-react/core';

import { AnychatFaIcon, AnyTagIcon } from '@anyx/shared-icons';

import { Tag, TagType } from '../..';

const getBaseProps = ({ type = 'default' }: { type: TagType }) => {
  return {
    anytag: {
      title: (
        <div className="text-2xs flex items-center gap-1">
          <AnyTagIcon className="h-3 w-3" />
          <span className="text-gray-7">AnyTag</span>
        </div>
      ),
    },
    anychat: {
      title: (
        <div className="text-2xs flex items-center gap-1">
          <AnychatFaIcon className="h-3 w-3" />
          <span className="text-gray-7">Anychat</span>
        </div>
      ),
    },
    default: {
      title: '',
    },
  }[type];
};

export interface TagGroupOptionsProps<T extends { id: string; name: string }> {
  title?: ReactNode;
  type?: TagType;
  options?: T[];
  selected?: string[];
  handleSelect?: (option: T) => void;
}

export const TagGroupOptions = <T extends { id: string; name: string }>({
  type,
  options = [],
  selected,
  handleSelect,
}: TagGroupOptionsProps<T>) => {
  const { title } = getBaseProps({ type });

  return (
    <section className="bg-white">
      {title && (
        <header className="text-gray-7 text-2xs flex items-center justify-between p-2">
          {title}
        </header>
      )}
      {options.length > 0 && (
        <div className="break-anywhere relative flex max-h-36 flex-wrap gap-x-1 gap-y-1.5 overflow-x-clip overflow-y-auto rounded-sm border p-2">
          {options.map((option) => (
            <Combobox.Option
              key={`${type}-${option.id}`}
              className="hover:bg-gray-0 flex h-8 w-full items-center gap-2 px-2"
              value={option.name}
              onClick={() => handleSelect?.(option)}
            >
              <Checkbox readOnly checked={selected?.includes(option.id)} />
              <Tag type={type} label={option.name} size="sm" />
            </Combobox.Option>
          ))}
        </div>
      )}
    </section>
  );
};
